import { Form } from "antd";
import { useParams } from "react-router";

import { CardAttributesTable } from "src/app/features/CardImplementation/subFeatures/CardDefinition/subFeatures/CardAttribute/components/tables/CardAttributesTable";
import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";

export const CardAttributesTableField: FieldMethod = ({ field }: FormFieldFactoryProps) => {
    // We use the id from the URL to determine if we are in a create or edit mode.
    const { id } = useParams();

    return id ? (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <CardAttributesTable key={field.name} />
        </Form.Item>
    ) : (
        <CreateTablePlaceholderComponent />
    );
};
